export { headingsForStandardSetCode }

const defaultHeadings: { [key: string]: string } = {
  COACH: 'Alternate Assessment Standard',
  'DLM-EE': 'DLM Essential Elements',
  'DLM.EE': 'Dynamic Learning Maps Essential Elements',
  'NCSC-CCC': 'NCSC Core Connectors',
  'NCSC.CCC': 'NCSC Core Content Connectors',
  'NY-PreK': 'Pre-Kindergarten Standard',
  CPLF: 'California Preschool Learning Foundations',
  TPKG: 'Texas Pre-Kindergarten Guidelines',
  TPG: 'Texas Pre-Kindergarten Guidelines',
  'CA-ELD': 'California ELD',
  CCSS: 'Standards',
  'TEKS-2017': 'Texas Essential Knowledge and Skills',
  TEKS: 'Texas Essential Knowledge and Skills',
  ETEKS: 'Essence of Texas Essential Knowledge and Skills/STAAR Alternate 2',
  'TEKS.PCT': 'Texas Essential Knowledge and Skills for Positive Character Traits',
  'CA-PE': 'California Physical Education',
  'ILS-SEL': 'Social/Emotional Benchmarks',
  'TEKS-SCI': 'Texas Essential Knowledge and Skills for Science',
  IELDS: 'Illinois Early Learning and Development Standards',
  'CDC-AEM': 'CDC Act Early Milestones',
  NCSCoS: 'North Carolina Standards',
  'NCS': 'North Carolina Standards',
  'NC.SS': 'North Carolina Science Standards',
  'NC.ECS': 'North Carolina Extended Content Standards',
  NCFELD: 'North Carolina Foundations for Early Learning and Development',
  NCOS: 'North Carolina K-12 ELA Standard Course of Study',
  HELDS: 'Hawaii Early Learning and Development Standards',
  'HSA-Alt': 'Hawaii Alternate Assessment Performance Level Descriptors',
  HCPS: 'Hawaii Content and Performance Standards',
  OLS: 'Ohio Learning Standards',
  'OLS.SS': 'Ohio Learning Standards: Social Studies',
  OELDS: 'Ohio Early Learning Development Standards',
  'OLS-E': 'Ohio Learning Standards - Extended',
  'OLS-T': 'Ohio Learning Standards: Technology',
  'OLS-FL': 'Ohio Learning Standards: Financial Literacy',
  'OLS-PE': 'Ohio Learning Standards: Physical Education',
  'OLS.S': 'Ohio Learning Standards: Science',
  NYSNGLS: 'New York State Next Generation Learning Standards',
  MLS: 'Missouri Learning Standards',
  MELG: 'Missouri Early Learning Goals',
  NJSLS: 'New Jersey Student Learning Standards',
  'NJ.SLS': 'New Jersey Student Learning Standards',
  GSE: 'Georgia Standards of Excellence',
  GECS: 'GSE Extended Content Standards',
  GELDS: 'Georgia Early Learning and Development Standards',
  LSS: 'Louisiana Student Standards',
  'LSS.LC': 'Louisiana Student Standards: Connectors',
  LELDS: `Louisiana's Birth to Five Early Learning and Development Standards`,
  AZ: 'Arizona State Standards',
  AELS: 'Arizona Early Learning Standards',
  ARELS: 'Arkansas Early Learning Standards',
  'AZ.SEL': 'Arizona Social and Emotional Learning Competencies',
  VSOL: 'Virginia Standards of Learning',
  VASOL: 'Virginia Aligned Standards of Learning',
  SC: "Nebraska's College and Career Ready Standards for Science",
  'NE-SS': 'Nebraska Social Studies Standards',
  'NE-PE': 'Nebraska Physical Education Standards',
  'MD-PE': "Maryland's Physical Education Framework",
  MCF: 'Massachusetts Curriculum Frameworks',
  MAELG: 'Massachusetts Early Learning Guidelines',
  PCS: 'Pennsylvania Core Standards',
  PAEC: 'Pennsylvania Alternate Eligible Content',
  PEC: 'Pennsylvania Eligible Content',
  SCCCR: 'South Carolina College- and Career-Ready Standards',
  SCCCRP: 'South Carolina College- and Career-Ready Prioritized Standards',
  TSS: 'Tennessee State Standards',
  KS: 'Kansas Standards',
  IAS: 'Indiana Academic Standards',
  INCC: 'Indiana Content Connectors',
  IELF: 'Indiana Early Learning Foundations',
  ISELC: 'Indiana Social-Emotional Learning Competencies',
  MCCRS: 'Maryland College and Career-Ready Standards',
  WAAPF: 'Washington AIM Access Points Framework',
  WELDG: 'Washington State Early Learning and Development Guidelines',
  WASEL: 'Washington SEL Standards and Benchmarks',
  NVACS: 'Nevada Academic Content Standards',
  NVACSC: 'Nevada Academic Content Standard Connectors',
  KY: 'Kentucky Academic Standards',
  KYECS: 'Kentucky\'s Early Childhood Standards',
  'Alternate-K-PREP': 'Alternate Kentucky Performance Rating for Educational Progress',
  FL: "Florida's B.E.S.T. Standards",
  FLB: "Florida's B.E.S.T. Standards",
  MAFS: 'Mathematics Florida Standards Access Points',
  LAFS: 'Language Arts Florida Standards Access Points',
  FELDS: 'Florida Early Learning and Developmental Standard',
  'MS-CCRS': 'Mississippi College- and Career-Readiness Standards',
  'MS-AAAS': 'Mississippi Alternate Academic Achievement Standards',
  MELS: 'Mississippi Early Learning Standards',
  CAS: 'Colorado Academic Standards',
  CELDG: 'Colorado Early Learning & Development Guidelines',
  IDCS: 'Idaho Content Standards',
  IDCCC: 'Idaho Extended Content Standards Core Content Connectors',
  NMCCSS: 'New Mexico Common Core Standards',
  NMELG: 'New Mexico Early Learning Guidelines',
  NDCS: 'North Dakota Content Standards',
  IC: 'Iowa Core',
  WCPS: 'Wyoming Content and Performance Standards',
  WCSE: 'Wyoming Content Standards Extensions',
  WELS: 'Wyoming\'s Early Learning Standards',
  AAS: 'Arkansas Academic Standards',
  'AR': 'Arkansas Standards',
  ACS: 'Alabama Course of Study',
  ALAAS: 'Alabama Alternate Achievement Standards',
  'AL.CTE': 'Alabama Career and Technical Education',
  VTAA: 'Vermont Alternate Assessment Achievement Level Descriptors',
  OEAF: 'Oregon Essentialized Assessment Frameworks',
  MN: 'Minnesota Academic Standards',
  MAS: 'Minnesota Academic Standards',
  MASM: 'Minnesota Academic Standards in Mathematics',
  'MN-SEL': 'Minnesota\'s Social and Emotional Learning Competencies',
  ECIPs: 'Early Childhood Indicators of Progress: Minnesota’s Early Learning Standards',
  UTCS: 'Utah Core State Standards',
  AKCS: 'Alaska Content Standards',
  WVCCRS: 'West Virginia College and Career Readiness Standards',
  WVAAAS: 'West Virginia Alternate Academic Achievement Standards',
  'CAS-EEO': 'Extended Evidence Outcomes',
  OELALS: 'Oregon English Language Arts and Literacy Standards',
  NECCRS: 'Nebraska College and Career Ready Standards',
  SDSS: 'South Dakota State Standards',
  SDELG: 'South Dakota Early Learning Guidelines',
  WAS: 'Wisconsin Academic Standards',
  OKAS: 'Oklahoma Academic Standards',
  OELG: 'Oklahoma Early Learning Guidelines',
  MDELS: 'Maryland Early Learning Standards',
  WIS: 'Wisconsin Standards',
  WMELS: 'Wisconsin Model Early Learning Standards',
  WISEL: 'Wisconsin Social and Emotional Learning Competencies',
  RELDS: 'Rhode Island Early Learning and Development Standards',
  'RICS': 'Rhode Island Core Standards',
  'MS-SEL': 'Mississippi K-12 Social Emotional Learning Standards',
  MSCS: 'Missouri School Counseling Standards',
  KELS: 'Kansas Early Learning Standards',
  SECD: 'Kansas Social-Emotional Character Development Standards',
  VELS: 'Vermont Early Learning Standards',
  'OH-SEL': "Ohio's Social and Emotional Learning Standards",
  OELKS: "Oregon's Early Learning and Kindergarten Standards",
  'TEKS.PE': 'Texas Essential Knowledge and Skills for Physical Education',
  'TEKS.CTE': 'TEKS Career and Technical Education',
  'TEKS-P': 'Texas Process Standards',
  TXELG: 'Texas Infant, Toddler, and Three-Year-Old Early Learning Guidelines',
  ITELG: 'Texas Infant, Toddler, and Three-Year-Old Early Learning Guidelines',
  NJELS: 'New Jersey Early Learning Standards',
  'TEKS.SS': 'TEKS for Social Studies',
  'TEKS.ELPS': 'TEKS English Language Proficiency Standards',
  'OH.ELDS': "Ohio's Early Learning and Development Standards",
  AZELPS: 'Arizona English Language Proficiency Standards',
  MLR: 'Maine Learning Results',
  'ME-ELDS': 'Maine Early Learning and Development Standards',
  VESOL: 'Virginia Essentialized Standards of Learning',
  DCELS: 'District of Columbia Early Learning Standards',
  DELF: 'Delaware Early Learning Foundations',
  IELS: 'Iowa Early Learning Standards',
  GMS: 'Georgia Mathematics Standards',
  'NY.CDOS': 'New York Career Development and Occupational Studies',
  NYPKELS: 'New York Prekindergarten Early Learning Standards',
  MELDS: 'Michigan Early Learning and Development Standards',
  'SC.CCR': 'South Carolina College- and Career-Ready Standards',
  'WIDA.ELD': 'WIDA English Language Development Standards Framework',
  'NV.PKS': 'Nevada Pre-Kindergarten Standards',
  'NV.ELG': 'Nevada Infant and Toddler Early Learning Guidelines',
  'FL.RES': 'Florida Resiliency Education Standards',
  'ND.CS': 'North Dakota Content Standards',
  'NDELS': 'North Dakota Early Learning Standards',
  'ND.CTE': 'North Dakota Career and Technical Education',
  'INAS': 'Indiana Academic Standards',
  'INELS': 'Indiana Early Learning Standards',
  'NYSS': 'New York State K-12 Social Studies Framework',
  'NGSS': 'Next Generation Science Standards',
  'CTELDS': 'Connecticut Early Learning and Development Standards',
  'ASELD': 'Alabama Standards for Early Learning and Development',
  'NYS.SLS': 'New York State P-12 Science Learning Standards',
  'NDES': 'North Dakota Essential Skills',
  'MLS.S': 'Missouri Learning Standards',
  'TEKS.SCI': 'Texas Essential Knowledge and Skills for Science',
  'TEKS-SS': 'TEKS for Social Studies',
  'SOL': 'Virginia Standards of Learning',
  'NHES': 'National Health Education Standards',
  'NACS-PE': 'Nevada Academic Content Standards-Physical Education',
  'NPKS': 'Nevada Pre-Kindergarten Standards',
  'NDPECS': 'North Dakota Physical Education Content Standards',
  'KSELA': 'Kansas Standards for English Language Arts',
  'NDSSCS': 'North Dakota Social Studies Content Standards',
  'NVACS-H': 'Nevada Academic Content Standards for Health',
  'NVESCRS': 'Nevada Employability Skills for Career Readiness Standards',
  'NH-ELS': 'NH Early Learning Standards',
  'CA-T-SEL': 'Transformative Social and Emotional Learning',
  'NDSCS': 'North Dakota Science Content Standards',
  'PTKLF': 'California Preschool/Transitional Kindergarten Learning Foundations',
  'ECS': 'Georgia Extended Content Standards',
  'ELDS': 'Virginia\'s Early Learning & Development Standards',
  'GSELA': 'Georgia\'s K-12 Standards for English Language Arts',
  'HEGSE': 'Health Education Georgia Standards of Excellence',
  'HICCS': 'Hawai\'i Common Core Standards for English Language Arts',
  'IDCS.ELAL': 'Idaho Content Standards English Language Arts/Literacy',
  'KSECE': 'Kansas Early Learning Standards',
  'MD-ELS': 'Maryland Early Learning Standards',
  'SC-ELS': 'South Carolina Early Learning Standards',
  'USS-ELA': 'Utah State Standards for P-12 English Language Arts',
  'RIELDS': 'Rhode Island\'s Early Learning and Development Standards',
  'RISELS': 'RI Social Emotional Learning Standards',
  'TN-ELDS': 'Tennessee Early Learning Developmental Standards',
  'AELG': 'Alaska Early Learning Guidelines',
  'IELG': 'Idaho Early Learning Guidelines',
  'SC-CCR': 'South Carolina College and Career Ready Standards',
  'ELP': 'English Language Proficiency Standards',
  'LSS-S': 'Louisiana Student Standards - Science',
  'LA-ELDS': 'Louisiana\'s Early Learning & Development Standards',
  'PLSEC': 'Pennsylvania Learning Standards for Early Childhood',
  'MT-ELS': 'Montana Early Learning Standards',
  'AAAS': 'Alabama Alternative Achievement Standards',
  'TS': 'Alabama Transition Standards',
  'ELG': 'Nebraska\'s Birth to Five Learning and Development Standards',
  'GSE.PE': 'Georgia Standards of Excellence - Physical Education',
  'NECCRSEI': 'Nebraska CCR Standards Extended Indicators',
  'IAS-PE': 'Indiana Academic Standards: Physical Education',
  'WCSDC': 'Montana Whole Child Skill Development Competencies',
  'OMS': 'Oregon Mathematics Standards'
}

const profileSpecificHeadings: { [key: string]: { [key: string]: string } } = {
  CCSS: {
    wisconsin: 'Wisconsin Academic Standards',
    illinois: 'Illinois Learning Standards',
    michigan: 'Michigan Academic Standards',
    connecticut: 'Connecticut Core Standards'
  }
}

function headingsForStandardSetCode(setCode: string, { profileId }: { profileId: string }) {
  return (
    (profileSpecificHeadings?.[setCode]?.[profileId]) ||
    defaultHeadings?.[setCode]
  )
}
